import { forwardRef } from 'react'

import { Box, BoxProps } from '@mui/material'

export default forwardRef((props: BoxProps, ref) => {
	const { children } = props
	const { sx, ...rest } = props

	return (
		<Box
			ref={ref}
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				...sx,
			}}
			{...rest}
		>
			{children}
		</Box>
	)
})
